import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_GuardianshipCustodyAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_GuardianshipCustodyAssessment' className='file-pdf-document'>
            <div className='file-template'>
            <h3>
                    Guardianship/Custody Assessment Form
                </h3>
                <p className='750'>
                    <b> Date:</b><input type='date' id='txtDateReview' className='add-only' name='txtDateReview'/>
                </p>
                <p className='750'>
                    <span className='eleHeader'>Are you the biological or legally adoptive parent of the client?</span>                           
                    <input type='radio' id='rbLegally_Yes' name='rbLegally' className='add-only' value='1' /> Yes &nbsp;                          
                    <input type='radio' id='rbLegally_No' name='rbLegally' className='add-only' value='0' /> No
                </p>
                <p className='750'>
                    <span className='eleHeader'>If no, are you the legal guardian or custodian of the client?</span>                           
                    <input type='radio' id='rbLegally1_Yes' name='rbLegally1' className='add-only' value='1' /> Yes &nbsp;                           
                    <input type='radio' id='rbLegally1_No' name='rbLegally1' className='add-only' value='0' /> No
                </p>
                <p className='750'>
                    Please note that if you a legal guardian or custodian, you must provide a copy of the court documents naming you as the legal guardian or custodian of the client. 
                    A shelter order may be submitted to show temporary guardianship or custody, but it is important to remember that these documents are often only temporary. All documents submitted will become a permanent part of the client's medical record. 
                    Failure to provide these documents will result in the client either not being opened for services or existing services being discontinued.
                </p>
                <p className='750'>
                    <span className='eleHeader'>Is the provision of guardianship or custodial documentation required for this client?</span>                           
                    <input type='radio' id='rbLegally2_Yes' name='rbLegally2' className='add-only' value='1' /> Yes &nbsp;                           
                    <input type='radio' id='rbLegally2_No' name='rbLegally2' className='add-only' value='0' /> No
                </p>
                <p className='750'>
                    <span className='eleHeader'>Dis the provider receive a copy of the required guardianship or custodial documentation?</span>                           
                    <input type='radio' id='rbLegally3_Yes' name='rbLegally3' className='add-only' value='1' /> Yes &nbsp;                           
                    <input type='radio' id='rbLegally3_No' name='rbLegally3' className='add-only' value='0' /> No
                </p>
                <p className='750'>
                    <span className='eleHeader'>Does the submitted documentation have a start date? If yes, what is that date?</span>                           
                    <input type='radio' id='rbLegally4_Yes' name='rbLegally4' className='add-only' value='1' /> Yes &nbsp;                           
                    <input type='radio' id='rbLegally4_No' name='rbLegally4' className='add-only' value='0' /> No <br/>
                    <input type='text' id='txtStartDate' className='add-only' name='txtStartDate' />
                </p>
                <p className='750'>
                    <span className='eleHeader'>Does the submitted documentation have an expiration date? If yes, what is that date?</span>                           
                    <input type='radio' id='rbLegally5_Yes' name='rbLegally5' className='add-only' value='1' /> Yes &nbsp;                           
                    <input type='radio' id='rbLegally5_No' name='rbLegally5' className='add-only' value='0' /> No<br/>
                    <input type='text' id='txtExpirationDate' className='add-only' name='txtExpirationDate' />
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                        
                        </tr>
                    <tr>
                        <td className='w-375 small'>Client Parent Signature</td>
                        <td className='w-375 small'>Provider (Supervisor Signature Capability)</td>
                    </tr>
                </table>
                <p className='750'>
                    Please submit the guardianship or custodial documentation to the Office Manager to be uploaded into the client's electronic medical record.
                </p>

                
            </div>
        </form>

    )
}











